<template>

  <div v-if="userLoggedIn">
    Continuer avec...
    <br><br><br>

    <div v-if="userLoggedIn.iss == 'accounts.google.com'">
      {{userLoggedIn.name}}
      <img :src='userLoggedIn.picture' />
      <br><br><br>
      <button @click="continueSignin">Continue</button>
    </div>


    <div v-if="userLoggedIn.iss == 'accounts.facebook.com'">
      {{userLoggedIn.name}}
      <img :src='userLoggedIn.picture' />
      <br><br><br>
      <button @click="continueSignin">Continue</button>
    </div>
    
  </div>

</template>

<script>

import jwt_decode from 'jwt-decode';

export default {
  name: 'ContinueWith',
  
  data: function() {
    return {
      userId : null,
      userLoggedIn : null,
      federatedUser : null,
      federatedSvc : ''
    }
  },
  // computed: {
  //   decodedToken: function() {
  //     if (this.userLoggedIn != undefined)
  //       return jwt_decode(this.userLoggedIn)
  //     else return "not decoded"
  //   }
  // },
  methods:
  {
    setAmplifyEventsHooks : function()
    {

      this.$Amplify.Hub.listen("auth", ({ payload: { event, data } }) => {
      
        console.log(event, data);

        switch (event) {
          case "signIn":
            console.log("hub signin");
            // this.setState({ user: data });
            break;
          case "signOut":
            console.log("hub signout");
            // this.setState({ user: null });
            break;
          case "customOAuthState":
            console.log("hub custom");
            // this.setState({ customState: data });
        }
      });


      this.$Amplify.Auth.currentAuthenticatedUser()
        .then(user => {
          debugger;
          console.log("User already logged in");
          console.log(user);
          this.federatedSvc = user.iss;
          this.federatedUser = user;
          this.userLoggedIn = jwt_decode(this.$store.currentUser.token);
          this.$store.currentUser = user;
          console.log(this.userLoggedIn);
        })
        .catch(() => console.log("Not signed in"));

    },
    continueSignin : function() {
      debugger;
      if (this.federatedSvc == 'accounts.google.com') {
      
        this.$Amplify.Auth.federatedSignIn(
        'google',
        {
            token: this.federatedUser.getAuthResponse().id_token,
            expires_at: this.federatedUser.getAuthResponse().expires_at // the expiration timestamp
        },
        this.federatedUser.getId()
        ).then(() => {
            // If success, the user object you passed in Auth.federatedSignIn
            this.$Amplify.Auth.currentUserCredentials()
            .then(cred => {
              this.$cookies.set("Authorization", btoa(JSON.stringify(cred)), null, null, "winerz.click");
              // redirect
              console.log("OK to redirect");
            });
        }).catch(e => {
            console.log(e)
        });

      }

    }
  },
  mounted(){

    console.log(this.$store.FB);
    debugger;
    this.setAmplifyEventsHooks();

  }
  
}
</script>
